import React from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';
import { buildApiFormErrors } from '~/javascripts/admin/utils/apiErrors';
import { Button } from '../../../atoms/Buttons';
import FormErrorMessage from '../../../atoms/FormErrorMessage';
import Grid from '../../../atoms/Grid';
import Label from '../../../atoms/Label';
import Required from '../../../atoms/Required';
import TextBox from '../../../atoms/TextBox';

const FormGrid = styled(Grid.Container)`
  margin-top: 24px;

  ${Button} {
    margin: 24px 0;
  }

  ${Label} {
    margin-bottom: 0;
    line-height: 32px;
  }
`;

export type PrivateMoneySearchFields = {
  private_money_id: string;
};

const getApiError = buildApiFormErrors<keyof PrivateMoneySearchFields>({
  invalid_parameters: (error) => {
    const key = error.errors?.invalid?.[0] ?? 'root.unknown';

    return {
      key,
      error: {
        message: 'マネーフルIDの入力内容に誤りがあります',
      },
    };
  },
});

const PrivateMoneySearchForm = ({
  onSearch,
}: {
  onSearch: (data: PrivateMoneySearchFields) => void;
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<PrivateMoneySearchFields>();

  const onSubmit = async (data: PrivateMoneySearchFields) => {
    try {
      onSearch(data);
    } catch (e) {
      const { key: errorKey, error } = getApiError(await Promise.resolve(e));
      setError(errorKey, error);
    }
  };

  return (
    <FormGrid columnGap={32}>
      <Grid.Item size={2}>
        <Label>
          マネーフルID
          <Required />
        </Label>
      </Grid.Item>
      <Grid.Item size={4} flexDirection="column">
        <TextBox
          fullWidth
          {...register('private_money_id', { required: 'マネーフルIDを入力してください' })}
        />
        <FormErrorMessage name="private_money_id" errors={errors} />
      </Grid.Item>
      <Grid.Item size={4} />

      <Grid.Item nextRow>
        <Button onClick={handleSubmit(onSubmit)}>検索</Button>
      </Grid.Item>
    </FormGrid>
  );
};

export default PrivateMoneySearchForm;
